export default [{
    path: "/servicosPrestados",
    component: () => import("../views/ServicosPrestados"),
    meta: { requiresAuth: true },
}]